/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import { ChatState } from '../sharedcomponents/chat/chatSlice';
import { DocumentVersionWithoutGeneratedFieldsType } from '../sharedcomponents/algorithm/types';

/** Do nothing - this is use in creator */
export function addCreatorReducers(builder: ActionReducerMapBuilder<ChatState>): ActionReducerMapBuilder<ChatState> {
  return builder;
}
export function addCreatorExtraReducers(
  builder: ActionReducerMapBuilder<ChatState>
): ActionReducerMapBuilder<ChatState> {
  return builder;
}

export function getNextMaintenanceAt(documentVersion: DocumentVersionWithoutGeneratedFieldsType) {
  return documentVersion.docCredits.find((c) => c.title === 'Next maintenance')?.name;
}

export const deleteAllMyDocumentVersionLocksThunk: undefined | (() => any) = undefined;
